import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import Top from "./components/Top";
import Side from "./components/Side";
import Tsd from "./pages/Tsd";
import TsdSettings from "./pages/TsdSettings";
import Login from "./pages/Login";
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  return (
    <div className="layout d-flex">
      <Side
        isSidebarExpanded={isSidebarExpanded}
        isSidebarHovered={isSidebarHovered}
        setIsSidebarHovered={setIsSidebarHovered}
      />

      <div className="main-content flex-grow-1">
        <Top
          onToggleSidebar={toggleSidebar}
          isSidebarExpanded={isSidebarExpanded}
          isSidebarHovered={isSidebarHovered}
        />

        <div className={`container-fluid main-container ${isSidebarExpanded || isSidebarHovered ? "main-container-shifted" : ""}`}>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/tsd"
              element={
                <ProtectedRoute>
                  <Tsd />
                </ProtectedRoute>
              }
            />

            <Route
              path="/tsd_settings"
              element={
                <ProtectedRoute>
                  <TsdSettings />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
